import { render, staticRenderFns } from "./LiveAgentTicket.vue?vue&type=template&id=0c739c62"
import script from "./LiveAgentTicket.vue?vue&type=script&lang=ts"
export * from "./LiveAgentTicket.vue?vue&type=script&lang=ts"
import style0 from "./LiveAgentTicket.vue?vue&type=style&index=0&id=0c739c62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports